<template>
  <v-carousel height="300" cycle hide-delimiter-background show-arrows="hover">
    <h2>{{ Sucursal }}</h2>
    <v-carousel-item>
      <iframe
        :src="Ubicacion"
        width="auto"
        height="300"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </v-carousel-item>
    <v-carousel-item v-if="Foto != ''">
      <v-img
        class="imgdata"
        alt=""
        :src="require('@/assets/'+ Foto)"
        cover
        width="auto"
        height="300"
      />
    </v-carousel-item>
  </v-carousel>
  <p>
    {{ Descripcion }}
  </p>
  <p>{{ Telefono }}</p>
</template>
<script>
export default {
  props: {
    Sucursal: {
      type:String,
      default:''
    },
    Descripcion: {
      type:String,
      default:''
    },
    Ubicacion: {
      type:String,
      default:''
    },
    Telefono: {
      type:String,
      default:''
    },
    Foto: {
      type:String,
      default:''
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
@media (min-width: 1000px) {
  /* Ajusta este valor según el breakpoint que desees */
  iframe {
    width: 500px;
  }

  .imgdata {
    width: 500px;
  }
}

@media (max-width: 999px) {
  iframe {
    width: auto;
  }
  .imgdata {
    width: auto;
  }
}
</style>
